// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password__link{line-height:36px;cursor:pointer}`, "",{"version":3,"sources":["webpack://./bs-ui/src/app/pages/login/sign-in/SignIn.scss"],"names":[],"mappings":"AAAA,uBACE,gBAAA,CACA,cAAA","sourcesContent":[".forgot-password__link {\n  line-height: 36px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
